import { Components } from 'react-virtuoso';
import useProductDetailsListComponentsStyles from '../../../styles/productDetailsListComponents.styles';
import productDetailsListComponents from '../../../utils/productDetailsList.components';
import useCombinationLineStyles from '../../CombinationLine/styles/combinationLine.styles';

const kitDetailsListComponents: Components = {
  ...productDetailsListComponents,
  Item: ({ children, ...props }) => {
    const { classes } = useCombinationLineStyles();

    return (
      <div {...props} className={classes.root}>
        {children}
      </div>
    );
  },
  Group: (props) => {
    const { classes } = useProductDetailsListComponentsStyles();
    return <div {...props} id="product-details-header-group" className={classes.groupHeader} />;
  },
};

export default kitDetailsListComponents;
